import { useEffect } from "react";
import { SITE_URL } from "@/config/site";

interface SeoOptions {
  title: string;
  description?: string;
  path?: string;
}

function setMeta(name: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(path?: string) {
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!SITE_URL) {
    if (link) link.remove();
    return;
  }
  const url = SITE_URL.replace(/\/$/, "") + (path || "/");
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

export function useSeo({ title, description, path }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    if (description) {
      setMeta("description", description);
    }
    setCanonical(path);
  }, [title, description, path]);
}